<template>
  <span class="calculation-tooltip">
    <span class="glyphicon glyphicon-info-sign calculation-tooltip__icon"></span>
    <span class="calculation-tooltip__text">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: 'CalculationTooltip',
  props: {
    text: { type: String, required: true }
  }
};
</script>

<style scoped>
.calculation-tooltip {
  position: relative;
  display: inline-block;
  margin-left: 4px;
  vertical-align: middle;
}

.calculation-tooltip__icon {
  color: #999;
  font-size: 12px;
  cursor: help;
}

.calculation-tooltip__text {
  display: none;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 6px;
  padding: 6px 10px;
  max-width: 260px;
  min-width: 180px;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.4;
  color: #fff;
  background-color: #333;
  border-radius: 3px;
  text-align: left;
  white-space: normal;
  z-index: 1000;
}

.calculation-tooltip__text::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.calculation-tooltip:hover .calculation-tooltip__text {
  display: block;
}
</style>
